import Styled from "styled-components";

const WarehouseWrapper = Styled.div`
.image-overlay-wrapper {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    grid-gap: 16px;
    max-width:248px;
    img {
        object-fit: contain;
    }
}
&.wear-house-wrapper-ui{
    .drawer-overflow{
        padding: 0 !important;
        height:auto;
    h2 {
    color: #1565d8;
    }
}
}
.location-history-overlay-wrapper{
    .product {
        display: inline-flex;
        height: 101px;
        width: 488px;
        .image-div {
            display: flex;
            height: 88px;
            width: 487px;
            .image-container {
                display: flex;
                img {
                    border-radius: 2px;
                    min-width: 88px !important;
                    min-height: 88px !important;
                    max-width: 88px !important;
                    max-height: 88px !important;
                    object-fit: contain;
                    }
            }
        .content-div{
        padding-left: 8px;
        display: flex;
        flex-direction: column;
        width: 100%;
        .quantity-section{
            height: 100%;
            display: flex;
            justify-content: space-between;
            gap: 20px;
            .section-items{
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            }
        }
        .heading-text {
            font-size: 12px;
            font-weight: 400;
            color: #7e8a90;
            line-height: 16px;
            }
            .value-text {
            font-size: 14px;
            font-weight: 600;
            color: #4e5969;
            line-height: 18px;
            text-align: left;
            width: 100%;
            }
        }
        }
        .quantity-div {
            display: flex;
            flex-direction: column;
            height: 38px;
            width: 58px;
            margin-top: 20px;
        }
        .received-div{
        width:66px !important;
        }
    }
    padding: 24px;
    .header-ui-wrapper{
        display:flex;
        justify-content:space-between;
        padding-bottom:24px;
    }
    .drawer-header-location {
    display: flex;
    align-items: center;
    grid-gap: 8px;
    span{
    position: relative;
    top:2px;
    cursor: pointer;
    }
    h5 {
    margin: 0;
    font-size: 18px;
    font-weight: 700;
    line-height: 30px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #1565D8;
}
}
}
.Inventory-adjustment-content-wrapper{
    h6{
    font-size: 24px;
    font-weight: 600;
    line-height: 32px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color:#1F1F1F;
    }
    .textarea-reason-wrapper {
    margin-top: 24px;
    div {
    margin: 0;
}
}
    .inventory-inputs-wrapper {
    margin-top: 32px;
    .items-wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 12px;
    align-items:end;
    div {
    margin: 0px;
    span{
        input{
            height:32px;
        }
    }
}
}
}

    }
    .item-container {
    display: flex;
    align-items: center;
    grid-gap: 60px;
    margin-top:30px;
    padding-bottom: 8px;
    border-bottom: 1px solid #D9D9D9;
    .item-wrapper {
    display: flex;
    flex-direction: column;
    grid-row-gap: 6px;
    p {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    margin: 0;
}
.item-title {
    display: flex;
    align-items: center;
    grid-gap: 7px;
    img{
        width: 36px;
        height: 36px;
        object-fit:contain;
    }
    p {
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    margin: 0;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
}
}
}
.bar-items {
    display: flex;
    flex-direction: column;
    grid-row-gap: 4px;
    p {
    margin: 0;
    font-size: 14px;
    font-weight: 600;
    line-height: 18px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #4E5969;
    &:not(:last-child){
        color: #7E8A90;
        font-weight: 400;
        font-size: 12px;
        line-height: 16px;
    }
}
}
}
.drawer-body{
    padding:24px;
    .drawer-header-location {
    display: flex;
    align-items: center;
    grid-gap: 8px;
    span{
    position: relative;
    top:2px;
    cursor: pointer;
    }
    h5 {
    margin: 0;
    font-size: 18px;
    font-weight: 700;
    line-height: 30px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #1565D8;
}
}
.item-container {
    display: flex;
    align-items: center;
    grid-gap: 60px;
    margin-top:30px;
    padding-bottom: 8px;
    border-bottom: 1px solid #D9D9D9;
    .item-wrapper {
    display: flex;
    flex-direction: column;
    grid-row-gap: 6px;
    p {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    margin: 0;
}
.item-title {
    display: flex;
    align-items: center;
    grid-gap: 7px;
    p {
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    margin: 0;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
}
}
}
.bar-items {
    display: flex;
    flex-direction: column;
    grid-row-gap: 4px;
    p {
    margin: 0;
    font-size: 14px;
    font-weight: 600;
    line-height: 18px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #4E5969;
    &:not(:last-child){
        color: #7E8A90;
        font-weight: 400;
        font-size: 12px;
        line-height: 16px;
    }
}
}
}
.container-location-add-value {
    margin-top: 32px;
.inputs-ui-location {
    display: grid;
    grid-template-columns: 1fr 2fr 2fr 1fr;
    align-items: flex-start;
    grid-gap: 12px;
    div{
        margin:0;
        span{
            input{
                height:33px;
            }
        }
    }
    .add-icon{
        padding-top: 25px;
        cursor: pointer;
    }
}
.items-content-wrapper-location{
    max-height: calc(100vh - 300px);
    height: auto;
    overflow: auto;
    .items-content-wrapper-location-item{
        display: grid;
        grid-template-columns: 1fr 2fr 2fr 1fr;
        align-items: flex-start;
        grid-gap: 12px;
        padding-top:18px;
        padding-left:4px;
        p{
            margin:0;
            font-size: 12px;
            font-weight: 400;
            line-height: 16px;
            text-align: left;
            text-underline-position: from-font;
            text-decoration-skip-ink: none;
            color: #7E8A90;
        }
        img{
            padding-left:16px;
            cursor: pointer;
        }
        svg.color-danger{
            margin-left: 6px;
        }
}
}
}
.footer-buttons {
    display: flex;
    align-items: center;
    justify-content: end;
    grid-gap: 8px;
    padding-top: 16px;
    padding-right:70px;
}
}
.edit-modal-wrapper{
    display: flex;
    flex-direction:column;
    grid-row-gap:16px;
    h2{
    margin:0;
    color: #1F1F1F;
    font-size: 24px;
    font-weight: 600;
    line-height: 32px;
    text-align: left;
    }
}
.delete-modal-wrapper{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  img{
    margin-bottom: 12px;
  }
  h3{
    font-size: 24px;
    font-weight: 600;
    line-height: 32px;
    text-align: left;
    color: ${({ theme }) => theme['headingColor']};
    margin: 0;
    margin-bottom: 4px;
  }
  p{
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    text-align: left;
    color:${({ theme }) => theme['body-text-color']};
    margin: 0;
  }
}
.download-btn {
    font-size: 12px;
}
.label-wrapper-location {
    display: flex;
    align-items: center;
    grid-gap: 24px;
    .info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    span {
    margin: 0;
    padding: 0 !important;!i;!;
    font-family: Titillium Web;
    font-size: 14px !important;!i;!;
    font-weight: 400;
    line-height: 18px;
    text-align: left;
    color: #212A2F;
   &:not(:last-child){
    color: #7E8A90;
}}
}
}
.card-wrapper {
    display: flex;
    img{
        width: 36px;
        height: 36px;
        object-fit: contain;
    }
  .two-line-ellipsis {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
    text-align: left;
    color: ${({ theme }) => theme['table-text']};
    height: 34px;
}
  }
  .customer-col-wrapper{
    display:flex;
    flex-direction: column;
    grid-row-gap:1.5px;
    p{
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
    text-align: left;
    margin:0 !important;
    color: #535E63;
    }
    span{
    font-size: 10px;
    font-weight: 600;
    line-height: 12px;
    text-align: left;
    color: #7E8A90;
    }
}
.product-image {
    width: 50px;
    height: 50px;
    border-radius: 8px;
    border: 1px solid #00A3FF;
    padding: 6px;
    cursor: pointer;
}
.image-count-wrapper {
    display: flex;
    align-items: center;
    grid-gap:8px;
    span.product-count-label {
        width: 35px;
        height: 35px;
        background: aliceblue;
        padding: 6px 9px;
        color: #1565D8;
        font-weight: 600;
        border-radius: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
}
.grid-column-gap-12{
    grid-column-gap:12px;
}
.recent-grey{
    color: ${({ theme }) => theme["regent_gray"]};
}
.grid-column-gap-2{
    grid-column-gap:2px;
}
.table-icon-centered{
    padding-top:8px;
}
&.unassigned-location{
    .table-icon-centered{
        padding-top:12px;
    }
    .last-section{
        display: flex;
        align-items: center;
        gap: 10px;
        width: 331px;

        .switch-section{
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 10px;
            font-size: small;
        }
    }
}
.drawer-padding{
    padding:24px;
    height:100vh;
    overflow:auto;
    .marketplace-information{
    border: 1px solid ${({ theme }) => theme["outline-color"]};
    background-color: ${({ theme }) => theme["outline-color"]}20;
    border-radius:${({ theme }) => theme["border-radius-base"]};
    padding:16px 12px;
    @media(max-width:1400px){
        grid-column-gap:8px;
    }
    h3{
        letter-spacing:0.2px;
    }
    .drawer-img {
     max-width: 90px !important;
    }
    .info{
        margin-top:15px;
        div{
            min-width:287px;
        }
        }
        .d-flex{
        &.padding-left:nth-child(2){
            min-width:203px;
            img{
                margin-top:9px;
            }
        }
      .d-flex{
        &.padding-left:nth-child(3){
            min-width: 169px;
            .sales-badge{
                    width:64px;
                    margin-top:5px;
                    padding:0 6px;
            }
        }
    }
       .d-flex{
        &.padding-left:nth-child(4){
            min-width: 115px; 
        }
    }
    }
}
.drawer-overflow{
    overflow-x:hidden!important;
}
.upload-description
{
    margin-top: 10px;
    padding-left: 1px;
    min-height:36px;
    p{
        /* font-size:${({theme})=> theme['base-font-size-small']}; */
    color:${({theme})=> theme['secondary-color']};
    /* margin-bottom:0; */
font-size: 14px;
font-weight: 400;
line-height: 18px;
text-align: left;
text-underline-position: from-font;
text-decoration-skip-ink: none;

    }
}
.relabel-description
{
    max-width: 357px;
    margin: 0 auto;
    margin-top: 10px;
    padding-left: 1px;
    min-height:36px;
    p{
        font-size:${({theme})=> theme['base-font-size-medium']};
    color:${({theme})=> theme['secondary-color']};
    margin-bottom:0;
    }
}
.info{
    margin-top:17px;
    margin-left:1px;
    &.cost-details{
         margin-top:16px;
           .details{
              padding-top:16px;
           }
    }
    &.source-order{
          margin-top:15px;
          margin-right:10px;
           .details{
              padding-top:13px;
           }
    }
    .details{
        flex-wrap:wrap;
        padding-top:18px;
        &.inputs{
            div{
            margin-bottom:0px;
        }
        }
        div{
            margin-bottom:8px;
        }
    }
}
}
.back-icon{
    grid-column-gap:13px;
    span{
        padding-left:6px;
    }
}

.right-content{
        margin-right: 13px;
    margin-top: 1px;
    .icon-filter{
        padding-left:21px;
    }
    .search-input{
          padding-left:12px;
    }
    .icon-column{
        padding-left:25px;
    }
    .pl-12{
        padding-left:12px;
    }
}
.date-picker{
    .rdrDateRangePickerWrapper{
    position: absolute;
    z-index: 1;
    box-shadow: 0 0 10px #ccc;
    left: -83px;
    top: 52px;  
    }
}
.search-input{
    position: absolute;
    top: 120px;
    right: 21px;
    z-index: 120;
    box-shadow: 0 0 10px #ccc;
        input{
            border: 1px solid #CFD8DC;
            color: ${({ theme }) => theme["cutty_sark"]};
            font-size: ${({ theme }) =>
        theme["medium-font-size"]};
            line-height:1.7;
            height:32px;
            min-width:288px;
            &:focus{
            border-color:#CFD8DC;
            box-shadow:none;
            color: ${({ theme }) => theme["cutty_sark"]};
            }
            &::placeholder{
            font-size: ${({ theme }) =>
        theme["medium-font-size"]};
            color: ${({ theme }) => theme["gray-color"]};
            }
    }
}
.name-details{
    display:grid;
    padding:9px 12px;
    border: 1px solid #4E5969;
    border-radius:8px;
    grid-gap:24px;
    margin-left: 5px;
    grid-template-columns: 1fr 5fr 0.5fr;
    .info{
        span:first-child{
            font-size: ${({ theme }) => theme["base-font-size-small"]};
        }
        span:nth-child(2){
            font-size: ${({ theme }) => theme["medium-font-size"]};
            color:${({ theme }) => theme["black-color"]};
            padding-left: 5px;
            &.success-badge{
                background-color:${({ theme }) => theme["success-color"]};
                color:${({ theme }) => theme["white-color"]};
                border-radius: 50px;
                padding: 0 10px;
            }
        }
        svg{
            width:10px;
            margin-right: 5px;
            margin-bottom: 3px;
        }
    }
}

.empty-data-container{
    .no-active-store-notification{
        background: ${({ theme }) =>
        theme["info-color"]};
        border: 1px solid #00A3FF;
        border-radius: 4px;
        display: flex;
        align-items:center;
        gap: 8px;
        padding: 8px 12px;
        padding-right:18px;
        font-weight: 600;
        font-size: 16px;
        line-height: 20px;
        color:${({ theme }) =>
        theme["black-color"]};
        .notification-icon{
            width: 20px;
        }
        .notification-text{
            display: flex;
            gap:8px;
            align-items:center;
        }
        &.drawer-no-active-store-notification{
            font-size:12px;
            line-height:14px;
            .notification-icon{
                width:16px;
            }
        }
    }
}  
.platform-list {
    gap: 16px;
    .platform-check {
        width: 137px;
        height: 74px;
        border: 1px solid ${({ theme }) => theme["outline-color"]};
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        cursor:pointer;
        img {
            width: 90px;
            height: 25px;
        }
        div {
         position: absolute;
         top: 2px;
         left: 8px;
        }
         .ant-checkbox-inner {
            width: 12px;
            height: 12px;
            &::after {
                width: 4px;
                height: 7px;
            }
         }
    }
    .active-platform {
        border: 1px solid ${({ theme }) => theme["primary-color"]};
    }
}
`;
export const AddProductManualModalWrapper = Styled.div`
.header-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 35px;
    height: fit-content;
    span {
    font-size: 18px;
    font-weight: 700;
    line-height: 30px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color:${({ theme }) => theme['primary-color']};
}
}
footer{
  display: flex;
align-items: center;
justify-content: end;
margin-top: 24px;
grid-gap: 16px;
}
`;

export const StepDataWrapper = Styled.div`
.box-wrapper{
  border: 1px solid ${({ theme }) => theme['border-color']};;
  border-radius: 8px;
  margin-top: 24px;
header{
  background-color: ${({ theme }) => theme['table-header-color']};
  padding: 12px 16px;
  border-top-right-radius: 8px;
border-top-left-radius: 8px;
  h6{
font-size: 12px;
font-weight: 600;
line-height: 14px;
text-align: left;
margin: 0;

  }
}
.body-wrapper{
  padding: 24px 16px;
  .form-wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    justify-content: space-between;
    align-items: flex-end;
    grid-gap: 16px;
    & > div{
      margin: 0;
    }
    .inputs {
    input{
      height: 34px;
    }
}
.select2-container.add-product-manual-wrapper{
  margin: 0;
}
.select2-selection__control.css-13cymwt-control {
    height: auto;
    min-height: auto;
    max-height: 100% !important;
}
}
}

}
.box-items-wrapper {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(168px, 1fr));
    grid-gap: 32px 12px;
    .add-product-manual-wrapper{
      margin: 0;
    }
    .value{
      display: flex;
      flex-direction: column;
      grid-row-gap: 8px;
      margin-top: 8px;
      p{
      font-size: 12px;
      font-weight: 400;
      line-height: 16px;
      text-align: left;
      margin: 0;
      }
    }
}
.box-container{
  border: 1px solid ${({ theme }) => theme['border-color']};
  border-radius: 4px;
  .header-ui-wrapper {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 2fr;
      &.new-header{
        grid-template-columns: 1fr 1fr 2fr;
      }
      span{
        padding: 8px 12px;
        font-size: 12px;
        font-weight: 400;
        line-height: 16px;
        text-align: left;
        color: #808183;
        &:not(:last-child) {
          border-right: 1px solid ${({ theme }) => theme['border-color']};
        }
      }
  }
  .scroll-able-content {
    min-height: 200px;
    overflow: auto;
    max-height: 350px;
  .body-boxes{
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 2fr;
    &.new-content{
        grid-template-columns: 1fr 1fr 1fr 2fr;
        &:last-child{
          border-bottom: 1px solid ${({ theme }) => theme['border-color']};
        }
      }
    span{
        padding: 8px 12px;
        font-size: 12px;
        font-weight: 400;
        line-height: 16px;
        text-align: left;
        color: ${({ theme }) => theme['table-text']};
        display: flex;
        align-items: center;
        grid-gap: 4px;
        border-top: 1px solid ${({ theme }) => theme['border-color']};
        &:not(:last-child) {
          border-right: 1px solid ${({ theme }) => theme['border-color']};
        }
        &:last-child{
          white-space: nowrap;     
          overflow: hidden;        
          text-overflow: ellipsis;
          display: inline-block;
        }
        img{    
          position: relative;
          top: -1px;
          padding-right: 4px;}
  }
}
  .no-errors-message {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100px;
    font-size: 16px;
    color: #555;
    text-align: center;
  }}
}
.congratulations-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 40px;
    grid-row-gap: 14px;
    h1 {
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
  text-align: left;
  margin: 0px !important;
  color: ${({theme}) => theme['label-color-new']};
}
p {
    font-size: 13px;
    font-weight: 400;
    line-height: 18px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    max-width: 333px;
    margin: 0;
    color: #5D5D5D;
}
button {
    max-width: 260px;
    width: 100%;
}
}
`;

export { WarehouseWrapper };
